import cx from 'classnames'

import type { TypographyStylesArgs } from './types'

export const typographyStyles = ({
  size = 'base',
  intensity,
  weight = 'normal',
}: TypographyStylesArgs | undefined = {}) =>
  cx(
    'transition-colors',
    intensity &&
      {
        primary: 'text-amaze-ink dark:text-amaze-inkBright',
        secondary: 'text-amaze-ink/75 dark:text-amaze-inkBright/75',
        tertiary: 'text-amaze-ink/50 dark:text-amaze-inkBright/50',
      }[intensity],
    {
      xs: 'text-xs',
      sm: 'text-sm',
      base: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
    }[size],
    {
      normal: 'font-normal',
      semibold: 'font-semibold',
      bold: 'font-bold',
    }[weight],
  )
